import { TelemetryType } from '../../api/apiservice'
import BaseSensor from './BaseSensor'

export default class PumpControl extends BaseSensor {
  constructor(props) {
    super(props, TelemetryType.PumpControl, 'Pump Control')
  }

  protected getDisplayReading(readingValue?: number): number | undefined {
    return readingValue
  }
}
